/**
 * RTL (Right-to-Left) language detection and utility functions
 */

/**
 * List of languages that use right-to-left text direction
 */
export const RTL_LANGUAGES = ['ar', 'he', 'fa'] as const;

export type RTLLanguage = typeof RTL_LANGUAGES[number];

/**
 * Determines if a given language code represents an RTL language
 * @param language - Language code (e.g., 'ar', 'en', 'ar_SA')
 * @returns true if the language is RTL, false otherwise
 */
export const isRTL = (language: string): boolean => {
  // Handle both underscore and hyphen separators for language variants
  const baseLanguage = language.split(/[_-]/)[0];
  return RTL_LANGUAGES.includes(baseLanguage as RTLLanguage);
};

/**
 * Gets the appropriate text direction for a language
 * @param language - Language code
 * @returns 'rtl' for RTL languages, 'ltr' for LTR languages
 */
export const getTextDirection = (language: string): 'rtl' | 'ltr' => {
  return isRTL(language) ? 'rtl' : 'ltr';
};


